import { QueryOperation, SearchQuery } from "../code/search-query/search-query";
import {
  buildSearchQuery,
  comboboxValue,
  numberValue,
  QueryFieldMapping,
} from "../code/search-query/query-mapper";
import { DataColumn } from "../controls/Data.default";
import { DynamicSchema } from "../controls/DynamicForm.default";
import { InputObject } from "../controls/default";

export interface FiscalPeriodsViewForm {
  readonly name?: string;
  readonly periodType?: InputObject;
  readonly year?: number;
}

// Fixed enum options for the PeriodType combobox (backend serializes the enum as a string).
export const periodTypeOptions = async (): Promise<InputObject[]> => [
  { display: "Year", value: "Year" },
  { display: "Semester", value: "Semester" },
  { display: "Quarter", value: "Quarter" },
];

export const fiscalPeriodsViewColumns: DataColumn[] = [
  { title: "Name", key: "name", width: 160, sort: true, defaultSort: "asc", fixed: "left" },
  { title: "Period Type", key: "periodType", width: 128, sort: true },
  { title: "Year", key: "year", width: 96, sort: true },
  { title: "Parent", key: "parentName", width: 128, sort: true },
  { title: "Start Date", key: "startDate", width: 128, sort: true },
  { title: "End Date", key: "endDate", width: 128, sort: true },
];

const fiscalPeriodsQueryMappings: QueryFieldMapping[] = [
  { formField: "name" },
  { formField: "periodType", queryField: "periodType", operation: QueryOperation.Equal, transform: comboboxValue },
  { formField: "year", queryField: "year", operation: QueryOperation.Equal, transform: numberValue },
];

// companyUid scoping is injected by the FiscalPeriodsView request wrapper, not here.
export const mapFiscalPeriodsViewQuery = (values: FiscalPeriodsViewForm): SearchQuery =>
  buildSearchQuery(values, fiscalPeriodsQueryMappings);

export const fiscalPeriodsSearchSchema: DynamicSchema = {
  groups: [
    {
      controls: [
        { type: "textbox", name: "name", label: "Name" },
        { type: "combobox", name: "periodType", label: "Period Type", request: periodTypeOptions },
        { type: "numberbox", name: "year", label: "Year" },
      ],
    },
  ],
};
